import { render, staticRenderFns } from "./ComenziFinalizate.vue?vue&type=template&id=45ac64e6&scoped=true"
import script from "./ComenziFinalizate.vue?vue&type=script&lang=js"
export * from "./ComenziFinalizate.vue?vue&type=script&lang=js"
import style0 from "./ComenziFinalizate.vue?vue&type=style&index=0&id=45ac64e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ac64e6",
  null
  
)

export default component.exports